import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  button: {
    padding: "8px 16px",
    color: "rgba(0, 0, 0, 0.54)",
  },
});
